export default __webpack_public_path__ + "static/media/plus2.be846d74.png";